import {type PushNotificationSchema} from '@capacitor/push-notifications';

export enum NotificationType {
    ACCIDENT_REPORT_CREATED = 'ACCIDENT_REPORT_CREATED',
    CHILD_CHECKIN_CREATED = 'CHILD_CHECKIN_CREATED',
    CHILD_LEAVE_CREATED = 'CHILD_LEAVE_CREATED',
    COMMENT_CREATED = 'COMMENT_CREATED',
    FEED_ITEM_CREATED = 'FEED_ITEM_CREATED',
    INQUIRY_CREATED = 'INQUIRY_CREATED',
    LATE_CHECKIN = 'LATE_CHECKIN',
    MESSAGE_CREATED = 'MESSAGE_CREATED',
    NAP_ENDED = 'NAP_ENDED',
    NAP_STARTED = 'NAP_STARTED',
    POST_OR_OBSERVATION_CREATED = 'POST_OR_OBSERVATION_CREATED',
}

interface BaseAdditionalData {
    type: NotificationType;
    [key: string]: any;
}

export interface AdditionalDataForMessage extends BaseAdditionalData {
    type: NotificationType.MESSAGE_CREATED;
    conversationId: string;
    messageId: string;
}

export type AdditionalData = BaseAdditionalData | AdditionalDataForMessage;

export interface PushNotification extends PushNotificationSchema {
    additionalData: AdditionalData;
}

export interface MessagePushNotification extends PushNotificationSchema {
    additionalData: AdditionalDataForMessage;
}
